export const ALLOW_TO_BYPASS = [
  'medicina.bsb@hsl.org.br',
  'medicina.trabalhosp@hsl.org.br',
];
